import axios from '@/plugins/axios';
import dayjs from 'dayjs';

const initialState = () => {
    return {
        holidays: [],
        holidaysForYear: [],
        selectedYear: dayjs().year()
    };
};

const state = () => initialState();

const getters = {
    getHolidays: state => state.holidays,
    getHolidaysForYear: state => state.holidaysForYear,
    getSelectedYear: state => state.selectedYear
};

const mutations = {
    setHolidays: (state, holidays) => {
        state.holidays = holidays;
    },
    setHolidaysForYear: (state, { data: holidays, year }) => {
        holidays.map(holiday => {
            const { repeat } = holiday;

            if (repeat) {
                holiday.date = dayjs(holiday.date)
                    .year(year)
                    .format('YYYY-MM-DD');
            }

            return holiday;
        });

        state.holidaysForYear = holidays;
        state.selectedYear = year;
    },
    clearState: state => {
        state.holidays = [];
        state.holidaysForYear = [];
        state.selectedYear = dayjs().year();
    }
};

const actions = {
    async fetch({ commit }) {
        const { data } = await axios.get('/holidays');

        commit('setHolidays', data);

        return data;
    },

    async fetchForYear({ commit }, { year, useMutation = true }) {
        const { data } = await axios.get('/holidays', {
            params: {
                filter: {
                    year
                }
            }
        });

        if (useMutation) {
            commit('setHolidaysForYear', { data, year });
        }

        return data;
    },

    async save({ dispatch, getters }, holiday) {
        const { id } = holiday;
        const { getSelectedYear } = getters;

        if (id) {
            await axios.put(`/holidays/${id}`, holiday);
        } else {
            await axios.post('/holidays', holiday);
        }

        await dispatch('fetchForYear', { year: getSelectedYear });
    },

    async importCsv(vuexContext, csvFile) {
        const csvData = new FormData();

        csvData.append('csvFile', csvFile);

        await axios.post('/holidays/import-csv', csvData);
    },

    async delete({ dispatch }, holiday) {
        const { id, date } = holiday;

        await axios.delete(`/holidays/${id}`);

        await dispatch('fetchForYear', { year: dayjs(date).year() });
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
